// extracted by mini-css-extract-plugin
export var card = "styles-module__card___fRqkr";
export var content = "styles-module__content___UVJwe";
export var name = "styles-module__name___K40Sj";
export var date = "styles-module__date___RU9YY";
export var edit = "styles-module__edit___rMscx";
export var favorite = "styles-module__favorite___neoEV";
export var inlineBlock = "styles-module__inlineBlock___SmsKT";
export var flex = "styles-module__flex___auKe0";